import React from "react";
import { useTranslation } from "react-i18next";
import Icon from "./Helpers/Icon";
import { PHONE_TEL, EMAIL } from "../contact";

// Spodní fixní lišta na mobilu (zobrazení řeší CSS: jen <768px).
function CallBar() {
  const { t } = useTranslation("menu");
  return (
    <div className="ms-callbar" aria-label="Rychlý kontakt">
      <a className="cb-call" href={`tel:${PHONE_TEL}`}>
        <Icon name="phone" /> {t("call")}
      </a>
      <a className="cb-email" href={`mailto:${EMAIL}`}>
        <Icon name="envelope" /> {t("writeEmail")}
      </a>
    </div>
  );
}

export default CallBar;
